var _metadata, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenSansRegularWebfont(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "open_sansregular",
    horizAdvX: 1171
  }, /*#__PURE__*/React.createElement("fontFace", {
    unitsPerEm: 2048,
    ascent: 1638,
    descent: -410
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 532
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uFB01",
    horizAdvX: 1212,
    d: "M29 0zM670 967h-279v-967h-166v967h-196v75l196 60v61q0 404 353 404q87 0 204 -35l-43 -133q-96 31 -164 31q-94 0 -139 -62.5t-45 -200.5v-71h279v-129zM1036 0h-166v1096h166v-1096zM856 1393q0 57 28 83.5t70 26.5q40 0 69 -27t29 -83t-29 -83.5t-69 -27.5 q-42 0 -70 27.5t-28 83.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uFB02",
    horizAdvX: 1212,
    d: "M29 0zM670 967h-279v-967h-166v967h-196v75l196 60v61q0 404 353 404q87 0 204 -35l-43 -133q-96 31 -164 31q-94 0 -139 -62.5t-45 -200.5v-71h279v-129zM1036 0h-166v1556h166v-1556z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uFB03",
    horizAdvX: 1909,
    d: "M29 0zM1358 967h-279v-967h-166v967h-196v75l196 60v61q0 404 353 404q87 0 204 -35l-43 -133q-96 31 -164 31q-94 0 -139 -62.5t-45 -200.5v-71h279v-129zM670 967h-279v-967h-166v967h-196v75l196 60v61q0 404 353 404q87 0 204 -35l-43 -133q-96 31 -164 31 q-94 0 -139 -62.5t-45 -200.5v-71h279v-129zM1731 0h-166v1096h166v-1096zM1551 1393q0 57 28 83.5t70 26.5q40 0 69 -27t29 -83t-29 -83.5t-69 -27.5q-42 0 -70 27.5t-28 83.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uFB04",
    horizAdvX: 1909,
    d: "M29 0zM1358 967h-279v-967h-166v967h-196v75l196 60v61q0 404 353 404q87 0 204 -35l-43 -133q-96 31 -164 31q-94 0 -139 -62.5t-45 -200.5v-71h279v-129zM670 967h-279v-967h-166v967h-196v75l196 60v61q0 404 353 404q87 0 204 -35l-43 -133q-96 31 -164 31 q-94 0 -139 -62.5t-45 -200.5v-71h279v-129zM1731 0h-166v1556h166v-1556z"
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 2048
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 2048
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\r",
    horizAdvX: 1044
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    horizAdvX: 532
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\t",
    horizAdvX: 532
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA0",
    horizAdvX: 532
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    horizAdvX: 547,
    d: "M326 403h-105l-51 1059h207zM152 106q0 136 120 136q58 0 89.5 -35t31.5 -101q0 -64 -32 -99.5t-89 -35.5q-52 0 -86 31.5t-34 103.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    horizAdvX: 821,
    d: "M319 1462l-40 -528h-105l-41 528h186zM688 1462l-41 -528h-104l-41 528h186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    horizAdvX: 1323,
    d: "M981 899l-66 -340h283v-129h-307l-84 -430h-137l84 430h-303l-82 -430h-136l80 430h-262v129h287l68 340h-277v127h299l82 436h139l-82 -436h305l84 436h134l-84 -436h264v-127h-289zM475 559h303l66 340h-303z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    d: "M1036 449q0 -136 -102 -224.5t-285 -111.5v-232h-129v223q-112 0 -217 17.5t-172 48.5v156q83 -37 191.5 -60.5t197.5 -23.5v440q-205 65 -287.5 151t-82.5 222q0 131 101.5 215t268.5 102v182h129v-180q184 -5 355 -74l-52 -131q-149 59 -303 70v-434q157 -50 235 -97.5 t115 -109t37 -149.5zM866 436q0 72 -44.5 116.5t-172.5 88.5v-389q217 30 217 184zM319 1057q0 -76 45 -122t156 -87v387q-99 -16 -150 -62.5t-51 -115.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    horizAdvX: 1686,
    d: "M242 1026q0 -170 37 -255t120 -85q164 0 164 340q0 338 -164 338q-83 0 -120 -84t-37 -254zM700 1026q0 -228 -76.5 -344.5t-224.5 -116.5q-140 0 -217.5 119t-77.5 342q0 227 74.5 342t220.5 115q145 0 223 -119t78 -338zM1122 440q0 -171 37 -255.5t121 -84.5t124 83.5 t40 256.5q0 171 -40 253.5t-124 82.5t-121 -82.5t-37 -253.5zM1581 440q0 -227 -76.5 -343.5t-224.5 -116.5q-142 0 -218.5 119t-76.5 341q0 227 74.5 342t220.5 115q142 0 221.5 -117.5t79.5 -339.5zM1323 1462l-811 -1462h-147l811 1462h147z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    horizAdvX: 1495,
    d: "M414 1171q0 -69 36 -131.5t123 -150.5q129 75 179.5 138.5t50.5 146.5q0 77 -51.5 125.5t-137.5 48.5q-89 0 -144.5 -48t-55.5 -129zM569 129q241 0 400 154l-437 424q-111 -68 -157 -112.5t-68 -95.5t-22 -116q0 -117 77.5 -185.5t206.5 -68.5zM113 379q0 130 69.5 230 t249.5 202q-85 95 -115.5 144t-48.5 102t-18 110q0 150 98 234t273 84q162 0 255 -83.5t93 -232.5q0 -107 -68 -197.5t-225 -183.5l407 -391q56 62 89.5 145.5t56.5 182.5h168q-68 -286 -205 -434l299 -291h-229l-185 178q-118 -106 -240 -152t-272 -46q-215 0 -333.5 106 t-118.5 293z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    horizAdvX: 453,
    d: "M319 1462l-40 -528h-105l-41 528h186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    horizAdvX: 606,
    d: "M82 561q0 265 77.5 496t223.5 405h162q-144 -193 -216.5 -424t-72.5 -475q0 -240 74 -469t213 -418h-160q-147 170 -224 397t-77 488z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    horizAdvX: 606,
    d: "M524 561q0 -263 -77.5 -490t-223.5 -395h-160q139 188 213 417.5t74 469.5q0 244 -72.5 475t-216.5 424h162q147 -175 224 -406.5t77 -494.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    horizAdvX: 1130,
    d: "M657 1556l-43 -395l398 111l26 -182l-381 -31l248 -326l-172 -94l-176 362l-160 -362l-176 94l242 326l-377 31l29 182l391 -111l-43 395h194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    d: "M653 791h412v-138h-412v-426h-139v426h-410v138h410v428h139v-428z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    horizAdvX: 502,
    d: "M350 238l15 -23q-26 -100 -75 -232.5t-102 -246.5h-125q27 104 59.5 257t45.5 245h182z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    horizAdvX: 659,
    d: "M84 473v152h491v-152h-491z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    horizAdvX: 545,
    d: "M152 106q0 67 30.5 101.5t87.5 34.5q58 0 90.5 -34.5t32.5 -101.5q0 -65 -33 -100t-90 -35q-51 0 -84.5 31.5t-33.5 103.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    horizAdvX: 752,
    d: "M731 1462l-545 -1462h-166l545 1462h166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    d: "M1069 733q0 -379 -119.5 -566t-365.5 -187q-236 0 -359 191.5t-123 561.5q0 382 119 567t363 185q238 0 361.5 -193t123.5 -559zM270 733q0 -319 75 -464.5t239 -145.5q166 0 240.5 147.5t74.5 462.5t-74.5 461.5t-240.5 146.5q-164 0 -239 -144.5t-75 -463.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    d: "M715 0h-162v1042q0 130 8 246q-21 -21 -47 -44t-238 -195l-88 114l387 299h140v-1462z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    d: "M1061 0h-961v143l385 387q176 178 232 254t84 148t28 155q0 117 -71 185.5t-197 68.5q-91 0 -172.5 -30t-181.5 -109l-88 113q202 168 440 168q206 0 323 -105.5t117 -283.5q0 -139 -78 -275t-292 -344l-320 -313v-8h752v-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    d: "M1006 1118q0 -140 -78.5 -229t-222.5 -119v-8q176 -22 261 -112t85 -236q0 -209 -145 -321.5t-412 -112.5q-116 0 -212.5 17.5t-187.5 61.5v158q95 -47 202.5 -71.5t203.5 -24.5q379 0 379 297q0 266 -418 266h-144v143h146q171 0 271 75.5t100 209.5q0 107 -73.5 168 t-199.5 61q-96 0 -181 -26t-194 -96l-84 112q90 71 207.5 111.5t247.5 40.5q213 0 331 -97.5t118 -267.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    d: "M1130 336h-217v-336h-159v336h-711v145l694 989h176v-983h217v-151zM754 487v486q0 143 10 323h-8q-48 -96 -90 -159l-457 -650h545z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    d: "M557 893q231 0 363.5 -114.5t132.5 -313.5q0 -227 -144.5 -356t-398.5 -129q-247 0 -377 79v160q70 -45 174 -70.5t205 -25.5q176 0 273.5 83t97.5 240q0 306 -375 306q-95 0 -254 -29l-86 55l55 684h727v-153h-585l-37 -439q115 23 229 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    d: "M117 625q0 431 167.5 644.5t495.5 213.5q113 0 178 -19v-143q-77 25 -176 25q-235 0 -359 -146.5t-136 -460.5h12q110 172 348 172q197 0 310.5 -119t113.5 -323q0 -228 -124.5 -358.5t-336.5 -130.5q-227 0 -360 170.5t-133 474.5zM608 121q142 0 220.5 89.5t78.5 258.5 q0 145 -73 228t-218 83q-90 0 -165 -37t-119.5 -102t-44.5 -135q0 -103 40 -192t113.5 -141t167.5 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    d: "M285 0l606 1309h-797v153h973v-133l-598 -1329h-184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    d: "M584 1483q200 0 317 -93t117 -257q0 -108 -67 -197t-214 -162q178 -85 253 -178.5t75 -216.5q0 -182 -127 -290.5t-348 -108.5q-234 0 -360 102.5t-126 290.5q0 251 306 391q-138 78 -198 168.5t-60 202.5q0 159 117.5 253.5t314.5 94.5zM268 369q0 -120 83.5 -187 t234.5 -67q149 0 232 70t83 192q0 97 -78 172.5t-272 146.5q-149 -64 -216 -141.5t-67 -185.5zM582 1348q-125 0 -196 -60t-71 -160q0 -92 59 -158t218 -132q143 60 202.5 129t59.5 161q0 101 -72.5 160.5t-199.5 59.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    d: "M1061 838q0 -858 -664 -858q-116 0 -184 20v143q80 -26 182 -26q240 0 362.5 148.5t133.5 455.5h-12q-55 -83 -146 -126.5t-205 -43.5q-194 0 -308 116t-114 324q0 228 127.5 360t335.5 132q149 0 260.5 -76.5t171.5 -223t60 -345.5zM569 1341q-143 0 -221 -92t-78 -256 q0 -144 72 -226.5t219 -82.5q91 0 167.5 37t120.5 101t44 134q0 105 -41 194t-114.5 140t-168.5 51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    horizAdvX: 545,
    d: "M152 106q0 67 30.5 101.5t87.5 34.5q58 0 90.5 -34.5t32.5 -101.5q0 -65 -33 -100t-90 -35q-51 0 -84.5 31.5t-33.5 103.5zM152 989q0 135 118 135q123 0 123 -135q0 -65 -33 -100t-90 -35q-51 0 -84.5 31.5t-33.5 103.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    horizAdvX: 545,
    d: "M350 238l15 -23q-26 -100 -75 -232.5t-102 -246.5h-125q27 104 59.5 257t45.5 245h182zM147 989q0 135 119 135q123 0 123 -135q0 -65 -33 -100t-90 -35q-58 0 -88.5 35t-30.5 100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    d: "M1065 242l-961 422v98l961 479v-149l-782 -371l782 -328v-151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    d: "M119 858v137h930v-137h-930zM119 449v137h930v-137h-930z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    d: "M104 393l783 326l-783 373v149l961 -479v-98l-961 -422v151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    horizAdvX: 879,
    d: "M289 403v54q0 117 36 192.5t134 159.5q136 115 171.5 173t35.5 140q0 102 -65.5 157.5t-188.5 55.5q-79 0 -154 -18.5t-172 -67.5l-59 135q189 99 395 99q191 0 297 -94t106 -265q0 -73 -19.5 -128.5t-57.5 -105t-164 -159.5q-101 -86 -133.5 -143t-32.5 -152v-33h-129z M240 106q0 136 120 136q58 0 89.5 -35t31.5 -101q0 -64 -32 -99.5t-89 -35.5q-52 0 -86 31.5t-34 103.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    horizAdvX: 1841,
    d: "M1720 729q0 -142 -44 -260t-124 -183t-184 -65q-86 0 -145 52t-70 133h-8q-40 -87 -114.5 -136t-176.5 -49q-150 0 -234.5 102.5t-84.5 278.5q0 204 118 331.5t310 127.5q68 0 154 -12.5t155 -34.5l-25 -470v-22q0 -178 133 -178q91 0 148 107.5t57 279.5q0 181 -74 317 t-210.5 209.5t-313.5 73.5q-223 0 -388 -92.5t-252 -264t-87 -396.5q0 -305 161 -469t464 -164q210 0 436 86v-133q-192 -84 -436 -84q-363 0 -563.5 199.5t-200.5 557.5q0 260 107 463t305 314.5t454 111.5q215 0 382.5 -90.5t259 -257t91.5 -383.5zM686 598 q0 -254 195 -254q207 0 225 313l14 261q-72 20 -157 20q-130 0 -203.5 -90t-73.5 -250z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    horizAdvX: 1296,
    d: "M1120 0l-182 465h-586l-180 -465h-172l578 1468h143l575 -1468h-176zM885 618l-170 453q-33 86 -68 211q-22 -96 -63 -211l-172 -453h473z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    horizAdvX: 1327,
    d: "M201 1462h413q291 0 421 -87t130 -275q0 -130 -72.5 -214.5t-211.5 -109.5v-10q333 -57 333 -350q0 -196 -132.5 -306t-370.5 -110h-510v1462zM371 836h280q180 0 259 56.5t79 190.5q0 123 -88 177.5t-280 54.5h-250v-479zM371 692v-547h305q177 0 266.5 68.5t89.5 214.5 q0 136 -91.5 200t-278.5 64h-291z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    horizAdvX: 1292,
    d: "M827 1331q-241 0 -380.5 -160.5t-139.5 -439.5q0 -287 134.5 -443.5t383.5 -156.5q153 0 349 55v-149q-152 -57 -375 -57q-323 0 -498.5 196t-175.5 557q0 226 84.5 396t244 262t375.5 92q230 0 402 -84l-72 -146q-166 78 -332 78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    horizAdvX: 1493,
    d: "M1368 745q0 -362 -196.5 -553.5t-565.5 -191.5h-405v1462h448q341 0 530 -189t189 -528zM1188 739q0 286 -143.5 431t-426.5 145h-247v-1168h207q304 0 457 149.5t153 442.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    horizAdvX: 1139,
    d: "M1016 0h-815v1462h815v-151h-645v-471h606v-150h-606v-538h645v-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    horizAdvX: 1057,
    d: "M371 0h-170v1462h815v-151h-645v-535h606v-151h-606v-625z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    horizAdvX: 1491,
    d: "M844 766h497v-711q-116 -37 -236 -56t-278 -19q-332 0 -517 197.5t-185 553.5q0 228 91.5 399.5t263.5 262t403 90.5q234 0 436 -86l-66 -150q-198 84 -381 84q-267 0 -417 -159t-150 -441q0 -296 144.5 -449t424.5 -153q152 0 297 35v450h-327v152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    horizAdvX: 1511,
    d: "M1311 0h-170v688h-770v-688h-170v1462h170v-622h770v622h170v-1462z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    horizAdvX: 571,
    d: "M201 0v1462h170v-1462h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    horizAdvX: 547,
    d: "M-12 -385q-94 0 -148 27v145q71 -20 148 -20q99 0 150.5 60t51.5 173v1462h170v-1448q0 -190 -96 -294.5t-276 -104.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    horizAdvX: 1257,
    d: "M1257 0h-200l-533 709l-153 -136v-573h-170v1462h170v-725l663 725h201l-588 -635z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    horizAdvX: 1063,
    d: "M201 0v1462h170v-1308h645v-154h-815z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    horizAdvX: 1849,
    d: "M848 0l-496 1296h-8q14 -154 14 -366v-930h-157v1462h256l463 -1206h8l467 1206h254v-1462h-170v942q0 162 14 352h-8l-500 -1294h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    horizAdvX: 1544,
    d: "M1343 0h-194l-799 1227h-8q16 -216 16 -396v-831h-157v1462h192l797 -1222h8q-2 27 -9 173.5t-5 209.5v839h159v-1462z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    horizAdvX: 1595,
    d: "M1470 733q0 -351 -177.5 -552t-493.5 -201q-323 0 -498.5 197.5t-175.5 557.5q0 357 176 553.5t500 196.5q315 0 492 -200t177 -552zM305 733q0 -297 126.5 -450.5t367.5 -153.5q243 0 367 153t124 451q0 295 -123.5 447.5t-365.5 152.5q-243 0 -369.5 -153.5 t-126.5 -446.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    horizAdvX: 1233,
    d: "M1128 1036q0 -222 -151.5 -341.5t-433.5 -119.5h-172v-575h-170v1462h379q548 0 548 -426zM371 721h153q226 0 327 73t101 234q0 145 -95 216t-296 71h-190v-594z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    horizAdvX: 1595,
    d: "M1470 733q0 -281 -113 -467t-319 -252l348 -362h-247l-285 330l-55 -2q-323 0 -498.5 197.5t-175.5 557.5q0 357 176 553.5t500 196.5q315 0 492 -200t177 -552zM305 733q0 -297 126.5 -450.5t367.5 -153.5q243 0 367 153t124 451q0 295 -123.5 447.5t-365.5 152.5 q-243 0 -369.5 -153.5t-126.5 -446.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    horizAdvX: 1266,
    d: "M371 608v-608h-170v1462h401q269 0 397.5 -103t128.5 -310q0 -290 -294 -392l397 -657h-201l-354 608h-305zM371 754h233q180 0 264 71.5t84 214.5q0 145 -85.5 209t-274.5 64h-221v-559z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    horizAdvX: 1124,
    d: "M1026 389q0 -193 -140 -301t-380 -108q-260 0 -400 67v164q90 -38 196 -60t210 -22q170 0 256 64.5t86 179.5q0 76 -30.5 124.5t-102 89.5t-217.5 93q-204 73 -291.5 173t-87.5 261q0 169 127 269t336 100q218 0 401 -80l-53 -148q-181 76 -352 76q-135 0 -211 -58 t-76 -161q0 -76 28 -124.5t94.5 -89t203.5 -89.5q230 -82 316.5 -176t86.5 -244z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    horizAdvX: 1133,
    d: "M651 0h-170v1311h-463v151h1096v-151h-463v-1311z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    horizAdvX: 1491,
    d: "M1305 1462v-946q0 -250 -151 -393t-415 -143t-408.5 144t-144.5 396v942h170v-954q0 -183 100 -281t294 -98q185 0 285 98.5t100 282.5v952h170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    horizAdvX: 1219,
    d: "M1036 1462h183l-527 -1462h-168l-524 1462h180l336 -946q58 -163 92 -317q36 162 94 323z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    horizAdvX: 1896,
    d: "M1477 0h-168l-295 979q-21 65 -47 164t-27 119q-22 -132 -70 -289l-286 -973h-168l-389 1462h180l231 -903q48 -190 70 -344q27 183 80 358l262 889h180l275 -897q48 -155 81 -350q19 142 72 346l230 901h180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    horizAdvX: 1182,
    d: "M1174 0h-193l-393 643l-400 -643h-180l486 764l-453 698h188l363 -579l366 579h181l-453 -692z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    horizAdvX: 1147,
    d: "M573 731l390 731h184l-488 -895v-567h-172v559l-487 903h186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    horizAdvX: 1169,
    d: "M1087 0h-1005v133l776 1176h-752v153h959v-133l-776 -1175h798v-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    horizAdvX: 674,
    d: "M623 -324h-457v1786h457v-141h-289v-1503h289v-142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    horizAdvX: 752,
    d: "M186 1462l547 -1462h-166l-544 1462h163z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    horizAdvX: 674,
    d: "M51 -182h289v1503h-289v141h457v-1786h-457v142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    horizAdvX: 1110,
    d: "M49 551l434 922h99l477 -922h-152l-372 745l-334 -745h-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    horizAdvX: 918,
    d: "M922 -315h-926v131h926v-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    horizAdvX: 1182,
    d: "M786 1241h-110q-65 52 -154 148t-129 159v21h203q32 -69 89 -159.5t101 -143.5v-25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    horizAdvX: 1139,
    d: "M850 0l-33 156h-8q-82 -103 -163.5 -139.5t-203.5 -36.5q-163 0 -255.5 84t-92.5 239q0 332 531 348l186 6v68q0 129 -55.5 190.5t-177.5 61.5q-137 0 -310 -84l-51 127q81 44 177.5 69t193.5 25q196 0 290.5 -87t94.5 -279v-748h-123zM475 117q155 0 243.5 85t88.5 238 v99l-166 -7q-198 -7 -285.5 -61.5t-87.5 -169.5q0 -90 54.5 -137t152.5 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    horizAdvX: 1255,
    d: "M686 1114q216 0 335.5 -147.5t119.5 -417.5t-120.5 -419.5t-334.5 -149.5q-107 0 -195.5 39.5t-148.5 121.5h-12l-35 -141h-119v1556h166v-378q0 -127 -8 -228h8q116 164 344 164zM662 975q-170 0 -245 -97.5t-75 -328.5t77 -330.5t247 -99.5q153 0 228 111.5t75 320.5 q0 214 -75 319t-232 105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    horizAdvX: 975,
    d: "M614 -20q-238 0 -368.5 146.5t-130.5 414.5q0 275 132.5 425t377.5 150q79 0 158 -17t124 -40l-51 -141q-55 22 -120 36.5t-115 14.5q-334 0 -334 -426q0 -202 81.5 -310t241.5 -108q137 0 281 59v-147q-110 -57 -277 -57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    horizAdvX: 1255,
    d: "M922 147h-9q-115 -167 -344 -167q-215 0 -334.5 147t-119.5 418t120 421t334 150q223 0 342 -162h13l-7 79l-4 77v446h166v-1556h-135zM590 119q170 0 246.5 92.5t76.5 298.5v35q0 233 -77.5 332.5t-247.5 99.5q-146 0 -223.5 -113.5t-77.5 -320.5q0 -210 77 -317 t226 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    horizAdvX: 1149,
    d: "M639 -20q-243 0 -383.5 148t-140.5 411q0 265 130.5 421t350.5 156q206 0 326 -135.5t120 -357.5v-105h-755q5 -193 97.5 -293t260.5 -100q177 0 350 74v-148q-88 -38 -166.5 -54.5t-189.5 -16.5zM594 977q-132 0 -210.5 -86t-92.5 -238h573q0 157 -70 240.5t-200 83.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    horizAdvX: 694,
    d: "M670 967h-279v-967h-166v967h-196v75l196 60v61q0 404 353 404q87 0 204 -35l-43 -133q-96 31 -164 31q-94 0 -139 -62.5t-45 -200.5v-71h279v-129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    horizAdvX: 1122,
    d: "M1073 1096v-105l-203 -24q28 -35 50 -91.5t22 -127.5q0 -161 -110 -257t-302 -96q-49 0 -92 8q-106 -56 -106 -141q0 -45 37 -66.5t127 -21.5h194q178 0 273.5 -75t95.5 -218q0 -182 -146 -277.5t-426 -95.5q-215 0 -331.5 80t-116.5 226q0 100 64 173t180 99 q-42 19 -70.5 59t-28.5 93q0 60 32 105t101 87q-85 35 -138.5 119t-53.5 192q0 180 108 277.5t306 97.5q86 0 155 -20h379zM199 -184q0 -89 75 -135t215 -46q209 0 309.5 62.5t100.5 169.5q0 89 -55 123.5t-207 34.5h-199q-113 0 -176 -54t-63 -155zM289 745q0 -115 65 -174 t181 -59q243 0 243 236q0 247 -246 247q-117 0 -180 -63t-63 -187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    horizAdvX: 1257,
    d: "M926 0v709q0 134 -61 200t-191 66q-173 0 -252.5 -94t-79.5 -308v-573h-166v1556h166v-471q0 -85 -8 -141h10q49 79 139.5 124.5t206.5 45.5q201 0 301.5 -95.5t100.5 -303.5v-715h-166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    horizAdvX: 518,
    d: "M342 0h-166v1096h166v-1096zM162 1393q0 57 28 83.5t70 26.5q40 0 69 -27t29 -83t-29 -83.5t-69 -27.5q-42 0 -70 27.5t-28 83.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    horizAdvX: 518,
    d: "M43 -492q-95 0 -154 25v135q69 -20 136 -20q78 0 114.5 42.5t36.5 129.5v1276h166v-1264q0 -324 -299 -324zM162 1393q0 57 28 83.5t70 26.5q40 0 69 -27t29 -83t-29 -83.5t-69 -27.5q-42 0 -70 27.5t-28 83.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    horizAdvX: 1075,
    d: "M340 561q43 61 131 160l354 375h197l-444 -467l475 -629h-201l-387 518l-125 -108v-410h-164v1556h164v-825q0 -55 -8 -170h8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    horizAdvX: 518,
    d: "M342 0h-166v1556h166v-1556z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    horizAdvX: 1905,
    d: "M1573 0v713q0 131 -56 196.5t-174 65.5q-155 0 -229 -89t-74 -274v-612h-166v713q0 131 -56 196.5t-175 65.5q-156 0 -228.5 -93.5t-72.5 -306.5v-575h-166v1096h135l27 -150h8q47 80 132.5 125t191.5 45q257 0 336 -186h8q49 86 142 136t212 50q186 0 278.5 -95.5 t92.5 -305.5v-715h-166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    horizAdvX: 1257,
    d: "M926 0v709q0 134 -61 200t-191 66q-172 0 -252 -93t-80 -307v-575h-166v1096h135l27 -150h8q51 81 143 125.5t205 44.5q198 0 298 -95.5t100 -305.5v-715h-166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    horizAdvX: 1237,
    d: "M1122 549q0 -268 -135 -418.5t-373 -150.5q-147 0 -261 69t-176 198t-62 302q0 268 134 417.5t372 149.5q230 0 365.5 -153t135.5 -414zM287 549q0 -210 84 -320t247 -110t247.5 109.5t84.5 320.5q0 209 -84.5 317.5t-249.5 108.5q-163 0 -246 -107t-83 -319z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    horizAdvX: 1255,
    d: "M686 -20q-107 0 -195.5 39.5t-148.5 121.5h-12q12 -96 12 -182v-451h-166v1588h135l23 -150h8q64 90 149 130t195 40q218 0 336.5 -149t118.5 -418q0 -270 -120.5 -419.5t-334.5 -149.5zM662 975q-168 0 -243 -93t-77 -296v-37q0 -231 77 -330.5t247 -99.5 q142 0 222.5 115t80.5 317q0 205 -80.5 314.5t-226.5 109.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    horizAdvX: 1255,
    d: "M590 119q166 0 242 89t81 300v37q0 230 -78 331t-247 101q-146 0 -223.5 -113.5t-77.5 -320.5t76.5 -315.5t226.5 -108.5zM565 -20q-212 0 -331 149t-119 416q0 269 120 420t334 151q225 0 346 -170h9l24 150h131v-1588h-166v469q0 100 11 170h-13q-115 -167 -346 -167z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 836,
    d: "M676 1116q73 0 131 -12l-23 -154q-68 15 -120 15q-133 0 -227.5 -108t-94.5 -269v-588h-166v1096h137l19 -203h8q61 107 147 165t189 58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    horizAdvX: 977,
    d: "M883 299q0 -153 -114 -236t-320 -83q-218 0 -340 69v154q79 -40 169.5 -63t174.5 -23q130 0 200 41.5t70 126.5q0 64 -55.5 109.5t-216.5 107.5q-153 57 -217.5 99.5t-96 96.5t-31.5 129q0 134 109 211.5t299 77.5q177 0 346 -72l-59 -135q-165 68 -299 68 q-118 0 -178 -37t-60 -102q0 -44 22.5 -75t72.5 -59t192 -81q195 -71 263.5 -143t68.5 -181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    horizAdvX: 723,
    d: "M530 117q44 0 85 6.5t65 13.5v-127q-27 -13 -79.5 -21.5t-94.5 -8.5q-318 0 -318 335v652h-157v80l157 69l70 234h96v-254h318v-129h-318v-645q0 -99 47 -152t129 -53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    horizAdvX: 1257,
    d: "M332 1096v-711q0 -134 61 -200t191 -66q172 0 251.5 94t79.5 307v576h166v-1096h-137l-24 147h-9q-51 -81 -141.5 -124t-206.5 -43q-200 0 -299.5 95t-99.5 304v717h168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    horizAdvX: 1026,
    d: "M416 0l-416 1096h178l236 -650q80 -228 94 -296h8q11 53 69.5 219.5t262.5 726.5h178l-416 -1096h-194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    horizAdvX: 1593,
    d: "M1071 0l-201 643q-19 59 -71 268h-8q-40 -175 -70 -270l-207 -641h-192l-299 1096h174q106 -413 161.5 -629t63.5 -291h8q11 57 35.5 147.5t42.5 143.5l201 629h180l196 -629q56 -172 76 -289h8q4 36 21.5 111t208.5 807h172l-303 -1096h-197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    horizAdvX: 1073,
    d: "M440 561l-381 535h189l289 -420l288 420h187l-381 -535l401 -561h-188l-307 444l-310 -444h-188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    horizAdvX: 1032,
    d: "M2 1096h178l240 -625q79 -214 98 -309h8q13 51 54.5 174.5t271.5 759.5h178l-471 -1248q-70 -185 -163.5 -262.5t-229.5 -77.5q-76 0 -150 17v133q55 -12 123 -12q171 0 244 192l61 156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    horizAdvX: 958,
    d: "M877 0h-795v113l598 854h-561v129h743v-129l-590 -838h605v-129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    horizAdvX: 776,
    d: "M475 12q0 -102 58.5 -148t171.5 -48v-140q-190 2 -294 87t-104 239v303q0 104 -63 148.5t-183 44.5v141q130 2 188 48t58 142v306q0 155 108 241t290 86v-139q-230 -6 -230 -199v-295q0 -215 -223 -254v-12q223 -39 223 -254v-297z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    horizAdvX: 1128,
    d: "M494 1556h141v-2052h-141v2052z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    horizAdvX: 776,
    d: "M522 575q-223 39 -223 254v295q0 193 -227 199v139q184 0 289.5 -87t105.5 -240v-306q0 -97 59 -142.5t189 -47.5v-141q-122 0 -185 -44.5t-63 -148.5v-303q0 -153 -102.5 -238.5t-292.5 -87.5v140q111 2 169 48t58 148v297q0 114 55 174t168 80v12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    d: "M338 713q-53 0 -116.5 -33.5t-117.5 -87.5v151q100 109 244 109q68 0 124.5 -14t145.5 -52q66 -28 115 -41.5t96 -13.5q54 0 118 32t118 89v-150q-102 -110 -244 -110q-72 0 -135 16.5t-135 48.5q-75 32 -120 44t-93 12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA1",
    horizAdvX: 547,
    d: "M219 684h105l51 -1057h-207zM393 983q0 -135 -121 -135q-60 0 -90 35.5t-30 99.5q0 63 31.5 99t88.5 36q51 0 86 -32t35 -103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA2",
    d: "M971 240q-105 -54 -252 -60v-200h-133v206q-203 32 -299.5 168.5t-96.5 386.5q0 508 396 570v172h135v-164q75 -3 146 -19.5t120 -39.5l-49 -140q-133 51 -242 51q-172 0 -253 -105.5t-81 -322.5q0 -212 79.5 -313.5t246.5 -101.5q141 0 283 59v-147z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA3",
    d: "M682 1481q190 0 360 -84l-61 -133q-154 77 -297 77q-123 0 -185.5 -62t-62.5 -202v-295h422v-127h-422v-221q0 -100 -32.5 -168t-106.5 -112h795v-154h-1029v141q205 47 205 291v223h-198v127h198v316q0 178 112 280.5t302 102.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA4",
    d: "M184 723q0 122 74 229l-135 140l94 92l135 -133q104 73 234 73q127 0 229 -73l137 133l95 -92l-134 -138q74 -113 74 -231q0 -131 -74 -234l131 -135l-92 -92l-137 133q-102 -71 -229 -71q-134 0 -234 73l-135 -133l-92 92l133 136q-74 107 -74 231zM313 723 q0 -112 78.5 -192t194.5 -80t195 79.5t79 192.5q0 114 -80 195t-194 81q-116 0 -194.5 -82t-78.5 -194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA5",
    d: "M584 735l379 727h174l-416 -770h262v-127h-317v-170h317v-127h-317v-268h-164v268h-316v127h316v170h-316v127h256l-411 770h178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA6",
    horizAdvX: 1128,
    d: "M494 1556h141v-776h-141v776zM494 281h141v-777h-141v777z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA7",
    horizAdvX: 1057,
    d: "M139 809q0 86 43 154.5t121 105.5q-74 40 -116 95.5t-42 140.5q0 121 103.5 190.5t300.5 69.5q94 0 173.5 -14.5t176.5 -53.5l-53 -131q-98 39 -165.5 52.5t-143.5 13.5q-116 0 -174 -29.5t-58 -93.5q0 -60 61.5 -102t215.5 -97q186 -68 261 -143.5t75 -182.5 q0 -90 -41 -160.5t-115 -111.5q153 -81 153 -227q0 -140 -117 -216.5t-329 -76.5q-218 0 -346 65v148q78 -37 175 -59.5t179 -22.5q134 0 204.5 38t70.5 109q0 46 -24 75t-78 58t-169 72q-142 52 -209 97t-100 102t-33 135zM285 829q0 -77 66 -129.5t233 -113.5l49 -19 q137 80 137 191q0 83 -73.5 139t-258.5 113q-68 -19 -110.5 -69t-42.5 -112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA8",
    horizAdvX: 1182,
    d: "M309 1393q0 52 26.5 75t63.5 23q38 0 65.5 -23t27.5 -75q0 -50 -27.5 -74.5t-65.5 -24.5q-37 0 -63.5 24.5t-26.5 74.5zM690 1393q0 52 26.5 75t63.5 23t64.5 -23t27.5 -75q0 -50 -27.5 -74.5t-64.5 -24.5t-63.5 24.5t-26.5 74.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA9",
    horizAdvX: 1704,
    d: "M893 1059q-125 0 -192.5 -87t-67.5 -241q0 -168 63.5 -249t194.5 -81q86 0 211 45v-124q-48 -20 -98.5 -34t-120.5 -14q-194 0 -298 120.5t-104 336.5q0 209 110.5 332t301.5 123q128 0 246 -60l-58 -118q-108 51 -188 51zM100 731q0 200 100 375t275 276t377 101 q200 0 375 -100t276 -275t101 -377q0 -197 -97 -370t-272 -277t-383 -104q-207 0 -382 103.5t-272.5 276.5t-97.5 371zM205 731q0 -173 87 -323.5t237.5 -237t322.5 -86.5q174 0 323 87t236.5 235.5t87.5 324.5q0 174 -87 323t-235.5 236.5t-324.5 87.5q-174 0 -323 -87 t-236.5 -235.5t-87.5 -324.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAA",
    horizAdvX: 725,
    d: "M532 801l-24 84q-92 -97 -232 -97q-95 0 -150.5 49.5t-55.5 151.5t77 154.5t242 58.5l117 4v39q0 133 -148 133q-100 0 -204 -51l-43 96q114 56 247 56q130 0 198.5 -52.5t68.5 -173.5v-452h-93zM193 989q0 -100 112 -100q201 0 201 180v49l-98 -4q-112 -4 -163.5 -32.5 t-51.5 -92.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAB",
    horizAdvX: 1018,
    d: "M82 551l342 407l119 -69l-289 -350l289 -351l-119 -71l-342 407v27zM477 551l344 407l117 -69l-287 -350l287 -351l-117 -71l-344 407v27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAC",
    d: "M1065 791v-527h-137v389h-824v138h961z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAD",
    horizAdvX: 659,
    d: "M84 473zM84 473v152h491v-152h-491z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAE",
    horizAdvX: 1704,
    d: "M723 762h108q80 0 128.5 41.5t48.5 105.5q0 75 -43 107.5t-136 32.5h-106v-287zM1157 913q0 -80 -42.5 -141.5t-119.5 -91.5l238 -395h-168l-207 354h-135v-354h-148v891h261q166 0 243.5 -65t77.5 -198zM100 731q0 200 100 375t275 276t377 101q200 0 375 -100t276 -275 t101 -377q0 -197 -97 -370t-272 -277t-383 -104q-207 0 -382 103.5t-272.5 276.5t-97.5 371zM205 731q0 -173 87 -323.5t237.5 -237t322.5 -86.5q174 0 323 87t236.5 235.5t87.5 324.5q0 174 -87 323t-235.5 236.5t-324.5 87.5q-174 0 -323 -87t-236.5 -235.5t-87.5 -324.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAF",
    horizAdvX: 1024,
    d: "M1030 1556h-1036v127h1036v-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB0",
    horizAdvX: 877,
    d: "M127 1171q0 130 90.5 221t220.5 91t221 -90.5t91 -221.5q0 -84 -41 -155.5t-114 -113.5t-157 -42q-130 0 -220.5 90t-90.5 221zM242 1171q0 -82 58.5 -139t139.5 -57q80 0 137.5 56.5t57.5 139.5q0 84 -56.5 140.5t-138.5 56.5q-83 0 -140.5 -57t-57.5 -140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB1",
    d: "M104 1zM653 791h412v-138h-412v-426h-139v426h-410v138h410v428h139v-428zM104 1v138h961v-138h-961z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB2",
    horizAdvX: 711,
    d: "M653 586h-604v104l236 230q89 86 130 134.5t57.5 86.5t16.5 92q0 68 -40 102.5t-103 34.5q-52 0 -101 -19t-118 -69l-66 88q131 111 283 111q132 0 205.5 -65t73.5 -177q0 -80 -44.5 -155.5t-191.5 -213.5l-174 -165h440v-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB3",
    horizAdvX: 711,
    d: "M627 1255q0 -80 -41 -131.5t-109 -74.5q176 -47 176 -209q0 -128 -92 -199.5t-260 -71.5q-152 0 -268 56v123q147 -68 270 -68q211 0 211 162q0 145 -231 145h-117v107h119q103 0 152.5 39.5t49.5 107.5q0 61 -40 95t-107 34q-66 0 -122 -21.5t-112 -56.5l-69 90 q63 45 133 72t164 27q136 0 214.5 -59.5t78.5 -166.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB4",
    horizAdvX: 1182,
    d: "M393 1266q48 62 103.5 150t87.5 153h202v-21q-44 -65 -131 -160t-151 -147h-111v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB5",
    horizAdvX: 1268,
    d: "M342 381q0 -262 254 -262q171 0 250.5 94.5t79.5 306.5v576h166v-1096h-136l-26 147h-10q-111 -167 -340 -167q-150 0 -238 92h-10q10 -84 10 -244v-320h-166v1588h166v-715z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB6",
    horizAdvX: 1341,
    d: "M1120 -260h-114v1712h-213v-1712h-115v819q-62 -18 -146 -18q-216 0 -317.5 125t-101.5 376q0 260 109 387t341 127h557v-1816z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB7",
    horizAdvX: 545,
    d: "M152 723q0 66 31 100.5t87 34.5q58 0 90.5 -34.5t32.5 -100.5q0 -65 -33 -100t-90 -35q-51 0 -84.5 31.5t-33.5 103.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB8",
    horizAdvX: 465,
    d: "M436 -289q0 -97 -76.5 -150t-226.5 -53q-51 0 -96 9v106q45 -8 104 -8q79 0 119.5 20t40.5 74q0 43 -39.5 69.5t-148.5 43.5l88 178h110l-55 -115q180 -39 180 -174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB9",
    horizAdvX: 711,
    d: "M338 1462h143v-876h-133v579q0 91 6 181q-22 -22 -49 -44.5t-162 -117.5l-67 96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBA",
    horizAdvX: 768,
    d: "M702 1135q0 -164 -85.5 -255.5t-235.5 -91.5q-146 0 -230.5 93t-84.5 254q0 163 84 253.5t235 90.5q152 0 234.5 -91t82.5 -253zM188 1135q0 -122 45.5 -183t149.5 -61q105 0 151 61t46 183q0 123 -46 182t-151 59q-103 0 -149 -59t-46 -182z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBB",
    horizAdvX: 1018,
    d: "M936 524l-344 -407l-117 71l287 351l-287 350l117 69l344 -407v-27zM541 524l-344 -407l-117 71l287 351l-287 350l117 69l344 -407v-27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBC",
    horizAdvX: 1597,
    d: "M75 0zM1298 1462l-903 -1462h-143l903 1462h143zM337 1462h143v-876h-133v579q0 91 6 181q-22 -22 -49 -44.5t-162 -117.5l-67 96zM1489 203h-125v-202h-145v202h-402v101l408 579h139v-563h125v-117zM1219 320v195q0 134 6 209q-5 -12 -17 -31.5t-27 -42l-30 -45 t-26 -39.5l-168 -246h262z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBD",
    horizAdvX: 1597,
    d: "M46 0zM1230 1462l-903 -1462h-143l903 1462h143zM308 1462h143v-876h-133v579q0 91 6 181q-22 -22 -49 -44.5t-162 -117.5l-67 96zM1499 1h-604v104l236 230q89 86 130 134.5t57.5 86.5t16.5 92q0 68 -40 102.5t-103 34.5q-52 0 -101 -19t-118 -69l-66 88 q131 111 283 111q132 0 205.5 -65t73.5 -177q0 -80 -44.5 -155.5t-191.5 -213.5l-174 -165h440v-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBE",
    horizAdvX: 1597,
    d: "M26 0zM620 1255q0 -80 -41 -131.5t-109 -74.5q176 -47 176 -209q0 -128 -92 -199.5t-260 -71.5q-152 0 -268 56v123q147 -68 270 -68q211 0 211 162q0 145 -231 145h-117v107h119q103 0 152.5 39.5t49.5 107.5q0 61 -40 95t-107 34q-66 0 -122 -21.5t-112 -56.5l-69 90 q63 45 133 72t164 27q136 0 214.5 -59.5t78.5 -166.5zM1390 1462l-903 -1462h-143l903 1462h143zM1569 203h-125v-202h-145v202h-402v101l408 579h139v-563h125v-117zM1299 320v195q0 134 6 209q-5 -12 -17 -31.5t-27 -42l-30 -45t-26 -39.5l-168 -246h262z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBF",
    horizAdvX: 879,
    d: "M590 684v-51q0 -122 -37.5 -196t-134.5 -158q-121 -106 -151.5 -143.5t-43 -76t-12.5 -94.5q0 -100 66 -156.5t188 -56.5q80 0 155 19t173 67l59 -135q-197 -96 -395 -96q-190 0 -298 93t-108 263q0 70 17.5 122.5t49.5 97t76.5 85.5t98.5 88q101 88 133.5 146t32.5 151 v31h131zM639 983q0 -135 -121 -135q-59 0 -90 34.5t-31 100.5q0 64 33 99.5t88 35.5q51 0 86 -32t35 -103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC0",
    horizAdvX: 1296,
    d: "M0 0zM1120 0l-182 465h-586l-180 -465h-172l578 1468h143l575 -1468h-176zM885 618l-170 453q-33 86 -68 211q-22 -96 -63 -211l-172 -453h473zM724 1579h-110q-65 52 -154 148t-129 159v21h203q32 -69 89 -159.5t101 -143.5v-25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC1",
    horizAdvX: 1296,
    d: "M0 0zM1120 0l-182 465h-586l-180 -465h-172l578 1468h143l575 -1468h-176zM885 618l-170 453q-33 86 -68 211q-22 -96 -63 -211l-172 -453h473zM526 1604q48 62 103.5 150t87.5 153h202v-21q-44 -65 -131 -160t-151 -147h-111v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC2",
    horizAdvX: 1296,
    d: "M0 0zM1120 0l-182 465h-586l-180 -465h-172l578 1468h143l575 -1468h-176zM885 618l-170 453q-33 86 -68 211q-22 -96 -63 -211l-172 -453h473zM303 1602q127 136 178 200t74 105h166q22 -42 76.5 -108.5t179.5 -196.5v-23h-119q-88 55 -221 186q-136 -134 -219 -186 h-115v23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC3",
    horizAdvX: 1296,
    d: "M0 0zM1120 0l-182 465h-586l-180 -465h-172l578 1468h143l575 -1468h-176zM885 618l-170 453q-33 86 -68 211q-22 -96 -63 -211l-172 -453h473zM792 1581q-43 0 -84 18.5t-80.5 41t-76 41t-70.5 18.5q-50 0 -75.5 -30t-39.5 -91h-98q13 121 70.5 189.5t148.5 68.5 q46 0 89 -18.5t82 -41t75 -41t68 -18.5q49 0 73 29.5t39 91.5h99q-13 -121 -69.5 -189.5t-150.5 -68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC4",
    horizAdvX: 1296,
    d: "M0 0zM1120 0l-182 465h-586l-180 -465h-172l578 1468h143l575 -1468h-176zM885 618l-170 453q-33 86 -68 211q-22 -96 -63 -211l-172 -453h473zM364 1731q0 52 26.5 75t63.5 23q38 0 65.5 -23t27.5 -75q0 -50 -27.5 -74.5t-65.5 -24.5q-37 0 -63.5 24.5t-26.5 74.5z M745 1731q0 52 26.5 75t63.5 23t64.5 -23t27.5 -75q0 -50 -27.5 -74.5t-64.5 -24.5t-63.5 24.5t-26.5 74.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC5",
    horizAdvX: 1296,
    d: "M0 0zM1120 0l-182 465h-586l-180 -465h-172l578 1468h143l575 -1468h-176zM885 618l-170 453q-33 86 -68 211q-22 -96 -63 -211l-172 -453h473zM870 1587q0 -98 -61.5 -157.5t-163.5 -59.5q-101 0 -161 58.5t-60 156.5t60.5 155.5t160.5 57.5q101 0 163 -59.5t62 -151.5z M762 1585q0 56 -33 86.5t-84 30.5t-84 -30.5t-33 -86.5t30 -86.5t87 -30.5q52 0 84.5 30.5t32.5 86.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC6",
    horizAdvX: 1788,
    d: "M1665 0h-750v465h-514l-227 -465h-176l698 1462h969v-151h-580v-471h541v-150h-541v-538h580v-152zM469 618h446v693h-118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC7",
    horizAdvX: 1292,
    d: "M125 0zM827 1331q-241 0 -380.5 -160.5t-139.5 -439.5q0 -287 134.5 -443.5t383.5 -156.5q153 0 349 55v-149q-152 -57 -375 -57q-323 0 -498.5 196t-175.5 557q0 226 84.5 396t244 262t375.5 92q230 0 402 -84l-72 -146q-166 78 -332 78zM950 -289q0 -97 -76.5 -150 t-226.5 -53q-51 0 -96 9v106q45 -8 104 -8q79 0 119.5 20t40.5 74q0 43 -39.5 69.5t-148.5 43.5l88 178h110l-55 -115q180 -39 180 -174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC8",
    horizAdvX: 1139,
    d: "M201 0zM1016 0h-815v1462h815v-151h-645v-471h606v-150h-606v-538h645v-152zM713 1579h-110q-65 52 -154 148t-129 159v21h203q32 -69 89 -159.5t101 -143.5v-25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC9",
    horizAdvX: 1139,
    d: "M201 0zM1016 0h-815v1462h815v-151h-645v-471h606v-150h-606v-538h645v-152zM456 1604q48 62 103.5 150t87.5 153h202v-21q-44 -65 -131 -160t-151 -147h-111v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCA",
    horizAdvX: 1139,
    d: "M201 0zM1016 0h-815v1462h815v-151h-645v-471h606v-150h-606v-538h645v-152zM263 1602q127 136 178 200t74 105h166q22 -42 76.5 -108.5t179.5 -196.5v-23h-119q-88 55 -221 186q-136 -134 -219 -186h-115v23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCB",
    horizAdvX: 1139,
    d: "M201 0zM1016 0h-815v1462h815v-151h-645v-471h606v-150h-606v-538h645v-152zM327 1731q0 52 26.5 75t63.5 23q38 0 65.5 -23t27.5 -75q0 -50 -27.5 -74.5t-65.5 -24.5q-37 0 -63.5 24.5t-26.5 74.5zM708 1731q0 52 26.5 75t63.5 23t64.5 -23t27.5 -75q0 -50 -27.5 -74.5 t-64.5 -24.5t-63.5 24.5t-26.5 74.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCC",
    horizAdvX: 571,
    d: "M5 0zM201 0v1462h170v-1462h-170zM398 1579h-110q-65 52 -154 148t-129 159v21h203q32 -69 89 -159.5t101 -143.5v-25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCD",
    horizAdvX: 571,
    d: "M179 0zM201 0v1462h170v-1462h-170zM179 1604q48 62 103.5 150t87.5 153h202v-21q-44 -65 -131 -160t-151 -147h-111v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCE",
    horizAdvX: 571,
    d: "M0 0zM201 0v1462h170v-1462h-170zM-57 1602q127 136 178 200t74 105h166q22 -42 76.5 -108.5t179.5 -196.5v-23h-119q-88 55 -221 186q-136 -134 -219 -186h-115v23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCF",
    horizAdvX: 571,
    d: "M5 0zM201 0v1462h170v-1462h-170zM5 1731q0 52 26.5 75t63.5 23q38 0 65.5 -23t27.5 -75q0 -50 -27.5 -74.5t-65.5 -24.5q-37 0 -63.5 24.5t-26.5 74.5zM386 1731q0 52 26.5 75t63.5 23t64.5 -23t27.5 -75q0 -50 -27.5 -74.5t-64.5 -24.5t-63.5 24.5t-26.5 74.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD0",
    horizAdvX: 1479,
    d: "M1352 745q0 -362 -196.5 -553.5t-565.5 -191.5h-389v649h-154v150h154v663h434q337 0 527 -187.5t190 -529.5zM1171 739q0 576 -569 576h-231v-516h379v-150h-379v-502h190q610 0 610 592z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD1",
    horizAdvX: 1544,
    d: "M201 0zM1343 0h-194l-799 1227h-8q16 -216 16 -396v-831h-157v1462h192l797 -1222h8q-2 27 -9 173.5t-5 209.5v839h159v-1462zM935 1581q-43 0 -84 18.5t-80.5 41t-76 41t-70.5 18.5q-50 0 -75.5 -30t-39.5 -91h-98q13 121 70.5 189.5t148.5 68.5q46 0 89 -18.5t82 -41 t75 -41t68 -18.5q49 0 73 29.5t39 91.5h99q-13 -121 -69.5 -189.5t-150.5 -68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD2",
    horizAdvX: 1595,
    d: "M125 0zM1470 733q0 -351 -177.5 -552t-493.5 -201q-323 0 -498.5 197.5t-175.5 557.5q0 357 176 553.5t500 196.5q315 0 492 -200t177 -552zM305 733q0 -297 126.5 -450.5t367.5 -153.5q243 0 367 153t124 451q0 295 -123.5 447.5t-365.5 152.5q-243 0 -369.5 -153.5 t-126.5 -446.5zM907 1579h-110q-65 52 -154 148t-129 159v21h203q32 -69 89 -159.5t101 -143.5v-25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD3",
    horizAdvX: 1595,
    d: "M125 0zM1470 733q0 -351 -177.5 -552t-493.5 -201q-323 0 -498.5 197.5t-175.5 557.5q0 357 176 553.5t500 196.5q315 0 492 -200t177 -552zM305 733q0 -297 126.5 -450.5t367.5 -153.5q243 0 367 153t124 451q0 295 -123.5 447.5t-365.5 152.5q-243 0 -369.5 -153.5 t-126.5 -446.5zM659 1604q48 62 103.5 150t87.5 153h202v-21q-44 -65 -131 -160t-151 -147h-111v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD4",
    horizAdvX: 1595,
    d: "M125 0zM1470 733q0 -351 -177.5 -552t-493.5 -201q-323 0 -498.5 197.5t-175.5 557.5q0 357 176 553.5t500 196.5q315 0 492 -200t177 -552zM305 733q0 -297 126.5 -450.5t367.5 -153.5q243 0 367 153t124 451q0 295 -123.5 447.5t-365.5 152.5q-243 0 -369.5 -153.5 t-126.5 -446.5zM448 1602q127 136 178 200t74 105h166q22 -42 76.5 -108.5t179.5 -196.5v-23h-119q-88 55 -221 186q-136 -134 -219 -186h-115v23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD5",
    horizAdvX: 1595,
    d: "M125 0zM1470 733q0 -351 -177.5 -552t-493.5 -201q-323 0 -498.5 197.5t-175.5 557.5q0 357 176 553.5t500 196.5q315 0 492 -200t177 -552zM305 733q0 -297 126.5 -450.5t367.5 -153.5q243 0 367 153t124 451q0 295 -123.5 447.5t-365.5 152.5q-243 0 -369.5 -153.5 t-126.5 -446.5zM942 1581q-43 0 -84 18.5t-80.5 41t-76 41t-70.5 18.5q-50 0 -75.5 -30t-39.5 -91h-98q13 121 70.5 189.5t148.5 68.5q46 0 89 -18.5t82 -41t75 -41t68 -18.5q49 0 73 29.5t39 91.5h99q-13 -121 -69.5 -189.5t-150.5 -68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD6",
    horizAdvX: 1595,
    d: "M125 0zM1470 733q0 -351 -177.5 -552t-493.5 -201q-323 0 -498.5 197.5t-175.5 557.5q0 357 176 553.5t500 196.5q315 0 492 -200t177 -552zM305 733q0 -297 126.5 -450.5t367.5 -153.5q243 0 367 153t124 451q0 295 -123.5 447.5t-365.5 152.5q-243 0 -369.5 -153.5 t-126.5 -446.5zM522 1731q0 52 26.5 75t63.5 23q38 0 65.5 -23t27.5 -75q0 -50 -27.5 -74.5t-65.5 -24.5q-37 0 -63.5 24.5t-26.5 74.5zM903 1731q0 52 26.5 75t63.5 23t64.5 -23t27.5 -75q0 -50 -27.5 -74.5t-64.5 -24.5t-63.5 24.5t-26.5 74.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD7",
    d: "M940 1176l96 -99l-352 -354l350 -352l-96 -99l-354 351l-348 -351l-101 99l350 352l-352 352l100 101l353 -355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD8",
    horizAdvX: 1595,
    d: "M1470 733q0 -351 -177.5 -552t-493.5 -201q-235 0 -383 100l-101 -141l-120 79l108 154q-178 198 -178 563q0 357 176 553.5t500 196.5q209 0 366 -94l97 135l120 -80l-106 -148q192 -202 192 -565zM1290 733q0 272 -110 426l-672 -948q115 -82 291 -82q243 0 367 153 t124 451zM305 733q0 -262 101 -416l669 943q-106 73 -274 73q-243 0 -369.5 -153.5t-126.5 -446.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD9",
    horizAdvX: 1491,
    d: "M186 0zM1305 1462v-946q0 -250 -151 -393t-415 -143t-408.5 144t-144.5 396v942h170v-954q0 -183 100 -281t294 -98q185 0 285 98.5t100 282.5v952h170zM856 1579h-110q-65 52 -154 148t-129 159v21h203q32 -69 89 -159.5t101 -143.5v-25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDA",
    horizAdvX: 1491,
    d: "M186 0zM1305 1462v-946q0 -250 -151 -393t-415 -143t-408.5 144t-144.5 396v942h170v-954q0 -183 100 -281t294 -98q185 0 285 98.5t100 282.5v952h170zM600 1604q48 62 103.5 150t87.5 153h202v-21q-44 -65 -131 -160t-151 -147h-111v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDB",
    horizAdvX: 1491,
    d: "M186 0zM1305 1462v-946q0 -250 -151 -393t-415 -143t-408.5 144t-144.5 396v942h170v-954q0 -183 100 -281t294 -98q185 0 285 98.5t100 282.5v952h170zM393 1602q127 136 178 200t74 105h166q22 -42 76.5 -108.5t179.5 -196.5v-23h-119q-88 55 -221 186 q-136 -134 -219 -186h-115v23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDC",
    horizAdvX: 1491,
    d: "M186 0zM1305 1462v-946q0 -250 -151 -393t-415 -143t-408.5 144t-144.5 396v942h170v-954q0 -183 100 -281t294 -98q185 0 285 98.5t100 282.5v952h170zM461 1731q0 52 26.5 75t63.5 23q38 0 65.5 -23t27.5 -75q0 -50 -27.5 -74.5t-65.5 -24.5q-37 0 -63.5 24.5 t-26.5 74.5zM842 1731q0 52 26.5 75t63.5 23t64.5 -23t27.5 -75q0 -50 -27.5 -74.5t-64.5 -24.5t-63.5 24.5t-26.5 74.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDD",
    horizAdvX: 1147,
    d: "M0 0zM573 731l390 731h184l-488 -895v-567h-172v559l-487 903h186zM442 1604q48 62 103.5 150t87.5 153h202v-21q-44 -65 -131 -160t-151 -147h-111v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDE",
    horizAdvX: 1251,
    d: "M1145 784q0 -227 -151.5 -346t-438.5 -119h-184v-319h-170v1462h170v-256h215q281 0 420 -103.5t139 -318.5zM371 465h168q226 0 327 71.5t101 235.5q0 149 -95 218t-297 69h-204v-594z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDF",
    horizAdvX: 1274,
    d: "M1049 1266q0 -135 -143 -250q-88 -70 -116 -103.5t-28 -66.5q0 -32 13.5 -53t49 -49.5t113.5 -79.5q140 -95 191 -173.5t51 -179.5q0 -160 -97 -245.5t-276 -85.5q-188 0 -295 69v154q63 -39 141 -62.5t150 -23.5q215 0 215 182q0 75 -41.5 128.5t-151.5 123.5 q-127 82 -175 143.5t-48 145.5q0 63 34.5 116t105.5 106q75 57 107 102t32 98q0 80 -68 122.5t-195 42.5q-276 0 -276 -223v-1204h-166v1202q0 178 110 271.5t332 93.5q206 0 318.5 -78.5t112.5 -222.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE0",
    horizAdvX: 1139,
    d: "M94 0zM850 0l-33 156h-8q-82 -103 -163.5 -139.5t-203.5 -36.5q-163 0 -255.5 84t-92.5 239q0 332 531 348l186 6v68q0 129 -55.5 190.5t-177.5 61.5q-137 0 -310 -84l-51 127q81 44 177.5 69t193.5 25q196 0 290.5 -87t94.5 -279v-748h-123zM475 117q155 0 243.5 85 t88.5 238v99l-166 -7q-198 -7 -285.5 -61.5t-87.5 -169.5q0 -90 54.5 -137t152.5 -47zM672 1241h-110q-65 52 -154 148t-129 159v21h203q32 -69 89 -159.5t101 -143.5v-25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE1",
    horizAdvX: 1139,
    d: "M94 0zM850 0l-33 156h-8q-82 -103 -163.5 -139.5t-203.5 -36.5q-163 0 -255.5 84t-92.5 239q0 332 531 348l186 6v68q0 129 -55.5 190.5t-177.5 61.5q-137 0 -310 -84l-51 127q81 44 177.5 69t193.5 25q196 0 290.5 -87t94.5 -279v-748h-123zM475 117q155 0 243.5 85 t88.5 238v99l-166 -7q-198 -7 -285.5 -61.5t-87.5 -169.5q0 -90 54.5 -137t152.5 -47zM436 1266q48 62 103.5 150t87.5 153h202v-21q-44 -65 -131 -160t-151 -147h-111v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE2",
    horizAdvX: 1139,
    d: "M94 0zM850 0l-33 156h-8q-82 -103 -163.5 -139.5t-203.5 -36.5q-163 0 -255.5 84t-92.5 239q0 332 531 348l186 6v68q0 129 -55.5 190.5t-177.5 61.5q-137 0 -310 -84l-51 127q81 44 177.5 69t193.5 25q196 0 290.5 -87t94.5 -279v-748h-123zM475 117q155 0 243.5 85 t88.5 238v99l-166 -7q-198 -7 -285.5 -61.5t-87.5 -169.5q0 -90 54.5 -137t152.5 -47zM228 1264q127 136 178 200t74 105h166q22 -42 76.5 -108.5t179.5 -196.5v-23h-119q-88 55 -221 186q-136 -134 -219 -186h-115v23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE3",
    horizAdvX: 1139,
    d: "M94 0zM850 0l-33 156h-8q-82 -103 -163.5 -139.5t-203.5 -36.5q-163 0 -255.5 84t-92.5 239q0 332 531 348l186 6v68q0 129 -55.5 190.5t-177.5 61.5q-137 0 -310 -84l-51 127q81 44 177.5 69t193.5 25q196 0 290.5 -87t94.5 -279v-748h-123zM475 117q155 0 243.5 85 t88.5 238v99l-166 -7q-198 -7 -285.5 -61.5t-87.5 -169.5q0 -90 54.5 -137t152.5 -47zM721 1243q-43 0 -84 18.5t-80.5 41t-76 41t-70.5 18.5q-50 0 -75.5 -30t-39.5 -91h-98q13 121 70.5 189.5t148.5 68.5q46 0 89 -18.5t82 -41t75 -41t68 -18.5q49 0 73 29.5t39 91.5h99 q-13 -121 -69.5 -189.5t-150.5 -68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE4",
    horizAdvX: 1139,
    d: "M94 0zM850 0l-33 156h-8q-82 -103 -163.5 -139.5t-203.5 -36.5q-163 0 -255.5 84t-92.5 239q0 332 531 348l186 6v68q0 129 -55.5 190.5t-177.5 61.5q-137 0 -310 -84l-51 127q81 44 177.5 69t193.5 25q196 0 290.5 -87t94.5 -279v-748h-123zM475 117q155 0 243.5 85 t88.5 238v99l-166 -7q-198 -7 -285.5 -61.5t-87.5 -169.5q0 -90 54.5 -137t152.5 -47zM279 1393q0 52 26.5 75t63.5 23q38 0 65.5 -23t27.5 -75q0 -50 -27.5 -74.5t-65.5 -24.5q-37 0 -63.5 24.5t-26.5 74.5zM660 1393q0 52 26.5 75t63.5 23t64.5 -23t27.5 -75 q0 -50 -27.5 -74.5t-64.5 -24.5t-63.5 24.5t-26.5 74.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE5",
    horizAdvX: 1139,
    d: "M94 0zM850 0l-33 156h-8q-82 -103 -163.5 -139.5t-203.5 -36.5q-163 0 -255.5 84t-92.5 239q0 332 531 348l186 6v68q0 129 -55.5 190.5t-177.5 61.5q-137 0 -310 -84l-51 127q81 44 177.5 69t193.5 25q196 0 290.5 -87t94.5 -279v-748h-123zM475 117q155 0 243.5 85 t88.5 238v99l-166 -7q-198 -7 -285.5 -61.5t-87.5 -169.5q0 -90 54.5 -137t152.5 -47zM804 1458q0 -98 -61.5 -157.5t-163.5 -59.5q-101 0 -161 58.5t-60 156.5t60.5 155.5t160.5 57.5q101 0 163 -59.5t62 -151.5zM696 1456q0 56 -33 86.5t-84 30.5t-84 -30.5t-33 -86.5 t30 -86.5t87 -30.5q52 0 84.5 30.5t32.5 86.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE6",
    horizAdvX: 1757,
    d: "M94 303q0 161 124 250.5t378 97.5l184 6v68q0 129 -58 190.5t-177 61.5q-144 0 -307 -84l-52 127q74 41 173.5 67.5t197.5 26.5q130 0 212.5 -43.5t123.5 -138.5q53 88 138.5 136t195.5 48q192 0 308 -133.5t116 -355.5v-107h-701q8 -395 322 -395q91 0 169.5 17.5 t162.5 56.5v-148q-86 -38 -160.5 -54.5t-175.5 -16.5q-289 0 -414 233q-81 -127 -179.5 -180t-232.5 -53q-163 0 -255.5 85t-92.5 238zM268 301q0 -95 53.5 -139.5t141.5 -44.5q145 0 229 84.5t84 238.5v99l-158 -7q-186 -8 -268 -62.5t-82 -168.5zM1225 977 q-121 0 -190.5 -83t-80.5 -241h519q0 156 -64 240t-184 84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE7",
    horizAdvX: 975,
    d: "M115 0zM614 -20q-238 0 -368.5 146.5t-130.5 414.5q0 275 132.5 425t377.5 150q79 0 158 -17t124 -40l-51 -141q-55 22 -120 36.5t-115 14.5q-334 0 -334 -426q0 -202 81.5 -310t241.5 -108q137 0 281 59v-147q-110 -57 -277 -57zM762 -289q0 -97 -76.5 -150t-226.5 -53 q-51 0 -96 9v106q45 -8 104 -8q79 0 119.5 20t40.5 74q0 43 -39.5 69.5t-148.5 43.5l88 178h110l-55 -115q180 -39 180 -174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE8",
    horizAdvX: 1149,
    d: "M115 0zM639 -20q-243 0 -383.5 148t-140.5 411q0 265 130.5 421t350.5 156q206 0 326 -135.5t120 -357.5v-105h-755q5 -193 97.5 -293t260.5 -100q177 0 350 74v-148q-88 -38 -166.5 -54.5t-189.5 -16.5zM594 977q-132 0 -210.5 -86t-92.5 -238h573q0 157 -70 240.5 t-200 83.5zM711 1241h-110q-65 52 -154 148t-129 159v21h203q32 -69 89 -159.5t101 -143.5v-25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE9",
    horizAdvX: 1149,
    d: "M115 0zM639 -20q-243 0 -383.5 148t-140.5 411q0 265 130.5 421t350.5 156q206 0 326 -135.5t120 -357.5v-105h-755q5 -193 97.5 -293t260.5 -100q177 0 350 74v-148q-88 -38 -166.5 -54.5t-189.5 -16.5zM594 977q-132 0 -210.5 -86t-92.5 -238h573q0 157 -70 240.5 t-200 83.5zM471 1266q48 62 103.5 150t87.5 153h202v-21q-44 -65 -131 -160t-151 -147h-111v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEA",
    horizAdvX: 1149,
    d: "M115 0zM639 -20q-243 0 -383.5 148t-140.5 411q0 265 130.5 421t350.5 156q206 0 326 -135.5t120 -357.5v-105h-755q5 -193 97.5 -293t260.5 -100q177 0 350 74v-148q-88 -38 -166.5 -54.5t-189.5 -16.5zM594 977q-132 0 -210.5 -86t-92.5 -238h573q0 157 -70 240.5 t-200 83.5zM259 1264q127 136 178 200t74 105h166q22 -42 76.5 -108.5t179.5 -196.5v-23h-119q-88 55 -221 186q-136 -134 -219 -186h-115v23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEB",
    horizAdvX: 1149,
    d: "M115 0zM639 -20q-243 0 -383.5 148t-140.5 411q0 265 130.5 421t350.5 156q206 0 326 -135.5t120 -357.5v-105h-755q5 -193 97.5 -293t260.5 -100q177 0 350 74v-148q-88 -38 -166.5 -54.5t-189.5 -16.5zM594 977q-132 0 -210.5 -86t-92.5 -238h573q0 157 -70 240.5 t-200 83.5zM319 1393q0 52 26.5 75t63.5 23q38 0 65.5 -23t27.5 -75q0 -50 -27.5 -74.5t-65.5 -24.5q-37 0 -63.5 24.5t-26.5 74.5zM700 1393q0 52 26.5 75t63.5 23t64.5 -23t27.5 -75q0 -50 -27.5 -74.5t-64.5 -24.5t-63.5 24.5t-26.5 74.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEC",
    horizAdvX: 518,
    d: "M0 0zM342 0h-166v1096h166v-1096zM355 1241h-110q-65 52 -154 148t-129 159v21h203q32 -69 89 -159.5t101 -143.5v-25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xED",
    horizAdvX: 518,
    d: "M169 0zM342 0h-166v1096h166v-1096zM169 1266q48 62 103.5 150t87.5 153h202v-21q-44 -65 -131 -160t-151 -147h-111v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEE",
    horizAdvX: 518,
    d: "M0 0zM342 0h-166v1096h166v-1096zM-77 1264q127 136 178 200t74 105h166q22 -42 76.5 -108.5t179.5 -196.5v-23h-119q-88 55 -221 186q-136 -134 -219 -186h-115v23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEF",
    horizAdvX: 518,
    d: "M0 0zM342 0h-166v1096h166v-1096zM-20 1393q0 52 26.5 75t63.5 23q38 0 65.5 -23t27.5 -75q0 -50 -27.5 -74.5t-65.5 -24.5q-37 0 -63.5 24.5t-26.5 74.5zM361 1393q0 52 26.5 75t63.5 23t64.5 -23t27.5 -75q0 -50 -27.5 -74.5t-64.5 -24.5t-63.5 24.5t-26.5 74.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF0",
    horizAdvX: 1221,
    d: "M1122 563q0 -281 -130.5 -432t-377.5 -151q-222 0 -361.5 134.5t-139.5 360.5q0 230 131.5 361t351.5 131q226 0 326 -121l8 4q-57 214 -262 405l-271 -155l-73 108l233 133q-92 62 -186 111l69 117q156 -73 258 -148l238 138l76 -107l-207 -119q152 -143 234.5 -342 t82.5 -428zM954 512q0 147 -90 232t-246 85q-337 0 -337 -360q0 -167 87.5 -258.5t249.5 -91.5q175 0 255.5 100.5t80.5 292.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF1",
    horizAdvX: 1257,
    d: "M176 0zM926 0v709q0 134 -61 200t-191 66q-172 0 -252 -93t-80 -307v-575h-166v1096h135l27 -150h8q51 81 143 125.5t205 44.5q198 0 298 -95.5t100 -305.5v-715h-166zM802 1243q-43 0 -84 18.5t-80.5 41t-76 41t-70.5 18.5q-50 0 -75.5 -30t-39.5 -91h-98 q13 121 70.5 189.5t148.5 68.5q46 0 89 -18.5t82 -41t75 -41t68 -18.5q49 0 73 29.5t39 91.5h99q-13 -121 -69.5 -189.5t-150.5 -68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF2",
    horizAdvX: 1237,
    d: "M115 0zM1122 549q0 -268 -135 -418.5t-373 -150.5q-147 0 -261 69t-176 198t-62 302q0 268 134 417.5t372 149.5q230 0 365.5 -153t135.5 -414zM287 549q0 -210 84 -320t247 -110t247.5 109.5t84.5 320.5q0 209 -84.5 317.5t-249.5 108.5q-163 0 -246 -107t-83 -319z M742 1241h-110q-65 52 -154 148t-129 159v21h203q32 -69 89 -159.5t101 -143.5v-25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF3",
    horizAdvX: 1237,
    d: "M115 0zM1122 549q0 -268 -135 -418.5t-373 -150.5q-147 0 -261 69t-176 198t-62 302q0 268 134 417.5t372 149.5q230 0 365.5 -153t135.5 -414zM287 549q0 -210 84 -320t247 -110t247.5 109.5t84.5 320.5q0 209 -84.5 317.5t-249.5 108.5q-163 0 -246 -107t-83 -319z M479 1266q48 62 103.5 150t87.5 153h202v-21q-44 -65 -131 -160t-151 -147h-111v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF4",
    horizAdvX: 1237,
    d: "M115 0zM1122 549q0 -268 -135 -418.5t-373 -150.5q-147 0 -261 69t-176 198t-62 302q0 268 134 417.5t372 149.5q230 0 365.5 -153t135.5 -414zM287 549q0 -210 84 -320t247 -110t247.5 109.5t84.5 320.5q0 209 -84.5 317.5t-249.5 108.5q-163 0 -246 -107t-83 -319z M282 1264q127 136 178 200t74 105h166q22 -42 76.5 -108.5t179.5 -196.5v-23h-119q-88 55 -221 186q-136 -134 -219 -186h-115v23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF5",
    horizAdvX: 1237,
    d: "M115 0zM1122 549q0 -268 -135 -418.5t-373 -150.5q-147 0 -261 69t-176 198t-62 302q0 268 134 417.5t372 149.5q230 0 365.5 -153t135.5 -414zM287 549q0 -210 84 -320t247 -110t247.5 109.5t84.5 320.5q0 209 -84.5 317.5t-249.5 108.5q-163 0 -246 -107t-83 -319z M773 1243q-43 0 -84 18.5t-80.5 41t-76 41t-70.5 18.5q-50 0 -75.5 -30t-39.5 -91h-98q13 121 70.5 189.5t148.5 68.5q46 0 89 -18.5t82 -41t75 -41t68 -18.5q49 0 73 29.5t39 91.5h99q-13 -121 -69.5 -189.5t-150.5 -68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF6",
    horizAdvX: 1237,
    d: "M115 0zM1122 549q0 -268 -135 -418.5t-373 -150.5q-147 0 -261 69t-176 198t-62 302q0 268 134 417.5t372 149.5q230 0 365.5 -153t135.5 -414zM287 549q0 -210 84 -320t247 -110t247.5 109.5t84.5 320.5q0 209 -84.5 317.5t-249.5 108.5q-163 0 -246 -107t-83 -319z M336 1393q0 52 26.5 75t63.5 23q38 0 65.5 -23t27.5 -75q0 -50 -27.5 -74.5t-65.5 -24.5q-37 0 -63.5 24.5t-26.5 74.5zM717 1393q0 52 26.5 75t63.5 23t64.5 -23t27.5 -75q0 -50 -27.5 -74.5t-64.5 -24.5t-63.5 24.5t-26.5 74.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF7",
    d: "M104 653v138h961v-138h-961zM471 373q0 60 29.5 90.5t83.5 30.5q52 0 81 -31.5t29 -89.5q0 -57 -29.5 -89t-80.5 -32q-52 0 -82.5 31.5t-30.5 89.5zM471 1071q0 60 29.5 90.5t83.5 30.5q52 0 81 -31.5t29 -89.5q0 -57 -29.5 -89t-80.5 -32q-52 0 -82.5 31.5t-30.5 89.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF8",
    horizAdvX: 1237,
    d: "M1122 549q0 -268 -135 -418.5t-373 -150.5q-154 0 -266 69l-84 -117l-114 78l94 131q-129 152 -129 408q0 268 134 417.5t372 149.5q154 0 270 -76l84 119l117 -76l-97 -133q127 -152 127 -401zM287 549q0 -171 53 -273l465 646q-75 53 -189 53q-163 0 -246 -107 t-83 -319zM950 549q0 164 -51 264l-465 -643q71 -51 184 -51q163 0 247.5 109.5t84.5 320.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF9",
    horizAdvX: 1257,
    d: "M164 0zM332 1096v-711q0 -134 61 -200t191 -66q172 0 251.5 94t79.5 307v576h166v-1096h-137l-24 147h-9q-51 -81 -141.5 -124t-206.5 -43q-200 0 -299.5 95t-99.5 304v717h168zM726 1241h-110q-65 52 -154 148t-129 159v21h203q32 -69 89 -159.5t101 -143.5v-25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFA",
    horizAdvX: 1257,
    d: "M164 0zM332 1096v-711q0 -134 61 -200t191 -66q172 0 251.5 94t79.5 307v576h166v-1096h-137l-24 147h-9q-51 -81 -141.5 -124t-206.5 -43q-200 0 -299.5 95t-99.5 304v717h168zM506 1266q48 62 103.5 150t87.5 153h202v-21q-44 -65 -131 -160t-151 -147h-111v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFB",
    horizAdvX: 1257,
    d: "M164 0zM332 1096v-711q0 -134 61 -200t191 -66q172 0 251.5 94t79.5 307v576h166v-1096h-137l-24 147h-9q-51 -81 -141.5 -124t-206.5 -43q-200 0 -299.5 95t-99.5 304v717h168zM286 1264q127 136 178 200t74 105h166q22 -42 76.5 -108.5t179.5 -196.5v-23h-119 q-88 55 -221 186q-136 -134 -219 -186h-115v23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFC",
    horizAdvX: 1257,
    d: "M164 0zM332 1096v-711q0 -134 61 -200t191 -66q172 0 251.5 94t79.5 307v576h166v-1096h-137l-24 147h-9q-51 -81 -141.5 -124t-206.5 -43q-200 0 -299.5 95t-99.5 304v717h168zM342 1393q0 52 26.5 75t63.5 23q38 0 65.5 -23t27.5 -75q0 -50 -27.5 -74.5t-65.5 -24.5 q-37 0 -63.5 24.5t-26.5 74.5zM723 1393q0 52 26.5 75t63.5 23t64.5 -23t27.5 -75q0 -50 -27.5 -74.5t-64.5 -24.5t-63.5 24.5t-26.5 74.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFD",
    horizAdvX: 1032,
    d: "M2 0zM2 1096h178l240 -625q79 -214 98 -309h8q13 51 54.5 174.5t271.5 759.5h178l-471 -1248q-70 -185 -163.5 -262.5t-229.5 -77.5q-76 0 -150 17v133q55 -12 123 -12q171 0 244 192l61 156zM411 1266q48 62 103.5 150t87.5 153h202v-21q-44 -65 -131 -160t-151 -147 h-111v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFE",
    horizAdvX: 1255,
    d: "M344 948q66 89 151 128.5t191 39.5q215 0 335 -150t120 -417q0 -268 -120.5 -418.5t-334.5 -150.5q-222 0 -344 161h-12l4 -34q8 -77 8 -140v-459h-166v2048h166v-466q0 -52 -6 -142h8zM664 975q-168 0 -244 -92t-78 -293v-41q0 -231 77 -330.5t247 -99.5q303 0 303 432 q0 215 -74 319.5t-231 104.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFF",
    horizAdvX: 1032,
    d: "M2 0zM2 1096h178l240 -625q79 -214 98 -309h8q13 51 54.5 174.5t271.5 759.5h178l-471 -1248q-70 -185 -163.5 -262.5t-229.5 -77.5q-76 0 -150 17v133q55 -12 123 -12q171 0 244 192l61 156zM234 1393q0 52 26.5 75t63.5 23q38 0 65.5 -23t27.5 -75q0 -50 -27.5 -74.5 t-65.5 -24.5q-37 0 -63.5 24.5t-26.5 74.5zM615 1393q0 52 26.5 75t63.5 23t64.5 -23t27.5 -75q0 -50 -27.5 -74.5t-64.5 -24.5t-63.5 24.5t-26.5 74.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0131",
    horizAdvX: 518,
    d: "M342 0h-166v1096h166v-1096z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0152",
    horizAdvX: 1890,
    d: "M1767 0h-768q-102 -20 -194 -20q-327 0 -503.5 196.5t-176.5 558.5q0 360 174 555t494 195q102 0 192 -23h782v-151h-589v-471h551v-150h-551v-538h589v-152zM811 1333q-249 0 -377.5 -152.5t-128.5 -447.5q0 -297 128.5 -450.5t375.5 -153.5q112 0 199 33v1141 q-87 30 -197 30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0153",
    horizAdvX: 1929,
    d: "M1430 -20q-293 0 -418 235q-62 -116 -166.5 -175.5t-241.5 -59.5q-223 0 -357 152.5t-134 416.5q0 265 131 415t366 150q131 0 233.5 -59.5t164.5 -173.5q58 112 154 172.5t222 60.5q201 0 320 -132.5t119 -358.5v-105h-729q8 -393 338 -393q94 0 174.5 17.5t167.5 56.5 v-148q-88 -39 -164 -55t-180 -16zM287 549q0 -211 76 -320.5t243 -109.5q163 0 239.5 106.5t76.5 315.5q0 221 -77.5 327.5t-242.5 106.5q-166 0 -240.5 -108t-74.5 -318zM1382 975q-127 0 -199.5 -82t-84.5 -240h544q0 158 -66 240t-194 82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0178",
    horizAdvX: 1147,
    d: "M0 0zM573 731l390 731h184l-488 -895v-567h-172v559l-487 903h186zM294 1731q0 52 26.5 75t63.5 23q38 0 65.5 -23t27.5 -75q0 -50 -27.5 -74.5t-65.5 -24.5q-37 0 -63.5 24.5t-26.5 74.5zM675 1731q0 52 26.5 75t63.5 23t64.5 -23t27.5 -75q0 -50 -27.5 -74.5 t-64.5 -24.5t-63.5 24.5t-26.5 74.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02C6",
    horizAdvX: 1212,
    d: "M268 1264q127 136 178 200t74 105h166q22 -42 76.5 -108.5t179.5 -196.5v-23h-119q-88 55 -221 186q-136 -134 -219 -186h-115v23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02DA",
    horizAdvX: 1182,
    d: "M813 1458q0 -98 -61.5 -157.5t-163.5 -59.5q-101 0 -161 58.5t-60 156.5t60.5 155.5t160.5 57.5q101 0 163 -59.5t62 -151.5zM705 1456q0 56 -33 86.5t-84 30.5t-84 -30.5t-33 -86.5t30 -86.5t87 -30.5q52 0 84.5 30.5t32.5 86.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02DC",
    horizAdvX: 1212,
    d: "M788 1243q-43 0 -84 18.5t-80.5 41t-76 41t-70.5 18.5q-50 0 -75.5 -30t-39.5 -91h-98q13 121 70.5 189.5t148.5 68.5q46 0 89 -18.5t82 -41t75 -41t68 -18.5q49 0 73 29.5t39 91.5h99q-13 -121 -69.5 -189.5t-150.5 -68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2000",
    horizAdvX: 953
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2001",
    horizAdvX: 1907
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2002",
    horizAdvX: 953
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2003",
    horizAdvX: 1907
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2004",
    horizAdvX: 635
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2005",
    horizAdvX: 476
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2006",
    horizAdvX: 317
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2007",
    horizAdvX: 317
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2008",
    horizAdvX: 238
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2009",
    horizAdvX: 381
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u200A",
    horizAdvX: 105
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2010",
    horizAdvX: 659,
    d: "M84 473v152h491v-152h-491z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2011",
    horizAdvX: 659,
    d: "M84 473v152h491v-152h-491z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2012",
    horizAdvX: 659,
    d: "M84 473v152h491v-152h-491z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2013",
    horizAdvX: 1024,
    d: "M82 473v152h860v-152h-860z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2014",
    horizAdvX: 2048,
    d: "M82 473v152h1884v-152h-1884z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2018",
    horizAdvX: 348,
    d: "M37 961l-12 22q22 90 71 224t105 255h123q-66 -254 -103 -501h-184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2019",
    horizAdvX: 348,
    d: "M309 1462l15 -22q-26 -100 -75 -232.5t-102 -246.5h-122q70 285 102 501h182z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201A",
    horizAdvX: 502,
    d: "M63 0zM350 238l15 -23q-26 -100 -75 -232.5t-102 -246.5h-125q27 104 59.5 257t45.5 245h182z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201C",
    horizAdvX: 717,
    d: "M406 961l-15 22q56 215 178 479h123q-30 -115 -59.5 -259.5t-42.5 -241.5h-184zM37 961l-12 22q22 90 71 224t105 255h123q-66 -254 -103 -501h-184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201D",
    horizAdvX: 717,
    d: "M309 1462l15 -22q-26 -100 -75 -232.5t-102 -246.5h-122q70 285 102 501h182zM678 1462l14 -22q-24 -91 -72 -224t-104 -255h-125q26 100 59 254t46 247h182z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201E",
    horizAdvX: 829,
    d: "M25 0zM309 238l15 -22q-26 -100 -75 -232.5t-102 -246.5h-122q70 285 102 501h182zM678 238l14 -22q-24 -91 -72 -224t-104 -255h-125q26 100 59 254t46 247h182z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2022",
    horizAdvX: 770,
    d: "M164 748q0 121 56.5 184t164.5 63q105 0 163 -62t58 -185q0 -119 -57.5 -183.5t-163.5 -64.5q-107 0 -164 65.5t-57 182.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2026",
    horizAdvX: 1606,
    d: "M152 0zM152 106q0 67 30.5 101.5t87.5 34.5q58 0 90.5 -34.5t32.5 -101.5q0 -65 -33 -100t-90 -35q-51 0 -84.5 31.5t-33.5 103.5zM682 106q0 67 30.5 101.5t87.5 34.5q58 0 90.5 -34.5t32.5 -101.5q0 -65 -33 -100t-90 -35q-51 0 -84.5 31.5t-33.5 103.5zM1213 106 q0 67 30.5 101.5t87.5 34.5q58 0 90.5 -34.5t32.5 -101.5q0 -65 -33 -100t-90 -35q-51 0 -84.5 31.5t-33.5 103.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u202F",
    horizAdvX: 381
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2039",
    horizAdvX: 623,
    d: "M82 551l342 407l119 -69l-289 -350l289 -351l-119 -71l-342 407v27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u203A",
    horizAdvX: 623,
    d: "M541 524l-344 -407l-117 71l287 351l-287 350l117 69l344 -407v-27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2044",
    horizAdvX: 266,
    d: "M655 1462l-903 -1462h-143l903 1462h143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u205F",
    horizAdvX: 476
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2074",
    horizAdvX: 711,
    d: "M692 788h-125v-202h-145v202h-402v101l408 579h139v-563h125v-117zM422 905v195q0 134 6 209q-5 -12 -17 -31.5t-27 -42l-30 -45t-26 -39.5l-168 -246h262z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u20AC",
    horizAdvX: 1208,
    d: "M795 1333q-319 0 -398 -403h510v-129h-524l-2 -57v-64l2 -45h463v-129h-447q37 -180 138.5 -278.5t271.5 -98.5q156 0 309 66v-150q-146 -65 -317 -65q-237 0 -381.5 134.5t-190.5 391.5h-166v129h152l-2 42v44l2 80h-152v129h164q39 261 185 407t383 146q201 0 366 -97 l-71 -139q-166 86 -295 86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2122",
    horizAdvX: 1589,
    d: "M369 741h-123v615h-209v106h543v-106h-211v-615zM969 741l-201 559h-8l6 -129v-430h-119v721h187l196 -559l203 559h180v-721h-127v420l6 137h-8l-211 -557h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2212",
    d: "M104 653v138h961v-138h-961z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uE000",
    horizAdvX: 1095,
    d: "M0 1095h1095v-1095h-1095v1095z"
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 1255,
    d: "M0 0z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0178",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0153",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xFC",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xFB",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xFA",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF9",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF8",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF6",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF5",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF4",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF3",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF2",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xEB",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xEA",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE9",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE8",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE7",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE6",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE5",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE4",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE3",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE2",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE1",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE0",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xDD",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC5",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC4",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC3",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC2",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC1",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC0",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "u",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "s",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "r",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "q",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "p",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "o",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "n",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "m",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "g",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "e",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "d",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "c",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "a",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "Y",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "W",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "V",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "T",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "A",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0178",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0153",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xFC",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xFB",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xFA",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF9",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF8",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF6",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF5",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF4",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF3",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF2",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xEB",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xEA",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE9",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE8",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE7",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE6",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE5",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE4",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE3",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE2",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE1",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE0",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xDD",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC5",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC4",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC3",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC2",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC1",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC0",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "u",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "s",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "r",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "q",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "p",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "o",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "n",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "m",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "g",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "e",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "d",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "c",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "a",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "Y",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "W",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "V",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "T",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "A",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "J",
    k: -184
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0178",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0152",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xDD",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xDC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xDB",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xDA",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD8",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD6",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD5",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD4",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD3",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD2",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xC7",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "Y",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "W",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "V",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "U",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "T",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "Q",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "O",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "G",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "C",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "T",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0178",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0152",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xDD",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xDC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xDB",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xDA",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD8",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD6",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD5",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD4",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD3",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD2",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xC7",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "Y",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "W",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "V",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "U",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "T",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "Q",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "O",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "G",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "C",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u201D",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2019",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0178",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0152",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xDD",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xD8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xD6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xD5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xD4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xD3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xD2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xC7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "Y",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "W",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "V",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "T",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "O",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "J",
    k: -266
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "'",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\"",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u201E",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u201A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0178",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\xDD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\xC5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\xC4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\xC3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\xC2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\xC1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\xC0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "Z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "Y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "X",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "W",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "T",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: ".",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: ",",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u0152",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\xD8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\xD6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\xD5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\xD4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\xD3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\xD2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\xC7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "O",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u201E",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u201A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0178",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xDD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xC5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xC4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xC3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xC2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xC1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xC0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "Z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "Y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "X",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "W",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "T",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: ".",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: ",",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "J",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u201E",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u201A",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "?",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0152",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xC7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "O",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u201D",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u2019",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0178",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0152",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xDD",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xDC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xDB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xDA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xC7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "Y",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "W",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "U",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "T",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "O",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "'",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\"",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u201E",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u201A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0178",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xDD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xC5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xC4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xC3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xC2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xC1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xC0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "Z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "Y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "X",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "W",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "T",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: ".",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: ",",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u201E",
    k: 266
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u201A",
    k: 266
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC5",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC4",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC3",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC2",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC1",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC0",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "Z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 266
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 266
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u201E",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u201A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0178",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xDD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "Z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "Y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "X",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "W",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "T",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: ".",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: ",",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u201E",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u201A",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u2014",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u2013",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0153",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0152",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFD",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFC",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFB",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFA",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF9",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF8",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF6",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF5",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF4",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF3",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF2",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEB",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEA",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE9",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE8",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE7",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE6",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE5",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE4",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE3",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE2",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE1",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE0",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xD8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xD6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xD5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xD4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xD3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xD2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC5",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC4",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC3",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC2",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC1",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC0",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "z",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "y",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "w",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "u",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "s",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "r",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "q",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "p",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "o",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "n",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "m",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "g",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "e",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "d",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "c",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "a",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "T",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "O",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "A",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "?",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ".",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "-",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ",",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u201E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u201A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xC5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xC4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xC3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xC2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xC1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xC0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: ".",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: ",",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201E",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201A",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0153",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0152",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEB",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEA",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC5",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC4",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC3",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC2",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC1",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC0",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "u",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "s",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "r",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "p",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "o",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "n",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "m",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "g",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "e",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "d",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "c",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "a",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "Q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "O",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "G",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "?",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ".",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ",",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u201E",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u201A",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0153",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0152",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xFC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xFB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xFA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEB",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEA",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xD8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xD6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xD5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xD4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xD3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xD2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC5",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC4",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC3",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC2",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC1",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC0",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "u",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "s",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "r",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "p",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "o",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "n",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "m",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "g",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "e",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "d",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "c",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "a",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "Q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "O",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "G",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "?",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ".",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ",",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0152",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xC7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "O",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u201E",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u201A",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0153",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0152",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xFC",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xFB",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xFA",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF9",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF8",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF6",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF5",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF4",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF3",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF2",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEB",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEA",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE9",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE8",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE7",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE6",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE5",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE4",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE3",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE2",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE1",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE0",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC5",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC4",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC3",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC2",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC1",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC0",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "z",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "u",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "s",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "r",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "q",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "p",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "o",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "n",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "m",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "g",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "e",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "d",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "c",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "a",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "O",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "A",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "?",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ".",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ",",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0152",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xD8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xD6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xD5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xD4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xD3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xD2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\xC7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "Q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "O",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "G",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "J",
    k: -184
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\xFD",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "y",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "w",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u201D",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u2019",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "'",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\"",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\xFD",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "y",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "w",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u201D",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u2019",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "'",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\"",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0153",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xEB",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xEA",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xE9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xE8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xE7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xE0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "o",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "e",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "d",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "c",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\xFD",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "y",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "w",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\xFD",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "y",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "w",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\u201D",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\u2019",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\u0153",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xEB",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xEA",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "o",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "g",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "e",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "d",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "c",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "a",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "'",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\"",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\u201D",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\u2019",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "'",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\"",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u201E",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u201D",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u201A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2019",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "?",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ".",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ",",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "'",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\"",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u201E",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u201D",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u201A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u2019",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "?",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ".",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ",",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "'",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\"",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0153",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xEB",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xEA",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "o",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "e",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "d",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "c",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u201E",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u201D",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u201A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u2019",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "?",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ".",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ",",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "'",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\"",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "J",
    k: -184
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u201D",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u2019",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0178",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0152",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xDD",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xD8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xD6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xD5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xD4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xD3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xD2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xC7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "Y",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "W",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "V",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "T",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "O",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "J",
    k: -266
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "'",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\"",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u201D",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u2019",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0178",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0152",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xDD",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xD8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xD6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xD5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xD4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xD3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xD2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xC7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "Y",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "W",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "V",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "T",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "O",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "J",
    k: -266
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "'",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\"",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u201D",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u2019",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0178",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0152",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xDD",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xD8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xD6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xD5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xD4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xD3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xD2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xC7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "Y",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "W",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "V",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "T",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "O",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "J",
    k: -266
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "'",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\"",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u201D",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u2019",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0178",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0152",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xDD",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xD8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xD6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xD5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xD4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xD3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xD2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xC7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "Y",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "W",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "V",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "T",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "O",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "J",
    k: -266
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "'",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\"",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u201D",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u2019",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0178",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0152",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xDD",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xD8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xD6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xD5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xD4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xD3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xD2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xC7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "Y",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "W",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "V",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "T",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "O",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "J",
    k: -266
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "'",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\"",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u201D",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u2019",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0178",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0152",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xDD",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xD8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xD6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xD5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xD4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xD3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xD2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xC7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "Y",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "W",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "V",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "T",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "O",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "J",
    k: -266
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "'",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\"",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC6",
    u2: "J",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\u0152",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\xD8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\xD6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\xD5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\xD4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\xD3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\xD2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\xC7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "O",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC8",
    u2: "J",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC9",
    u2: "J",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCA",
    u2: "J",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCB",
    u2: "J",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u201E",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u201A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0178",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xDD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xC5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xC4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xC3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xC2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xC1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xC0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "Z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "Y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "X",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "W",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "T",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: ".",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: ",",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u201E",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u201A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0178",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xDD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xC5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xC4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xC3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xC2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xC1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xC0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "Z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "Y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "X",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "W",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "T",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: ".",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: ",",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u201E",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u201A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0178",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xDD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xC5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xC4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xC3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xC2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xC1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xC0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "Z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "Y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "X",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "W",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "T",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: ".",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: ",",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u201E",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u201A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0178",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xDD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xC5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xC4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xC3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xC2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xC1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xC0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "Z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "Y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "X",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "W",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "T",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: ".",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: ",",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u201E",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u201A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0178",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xDD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xC5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xC4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xC3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xC2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xC1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xC0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "Z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "Y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "X",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "W",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "T",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: ".",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: ",",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u201E",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u201A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0178",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xDD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xC5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xC4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xC3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xC2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xC1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xC0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "Z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "Y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "X",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "W",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "T",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: ".",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: ",",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u201E",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u201A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0178",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\xDD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\xC5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\xC4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\xC3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\xC2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\xC1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\xC0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "Z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "Y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "X",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "W",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "T",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: ".",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: ",",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u201E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u201A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\xC5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\xC4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\xC3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\xC2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\xC1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\xC0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: ".",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: ",",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u201E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u201A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\xC5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\xC4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\xC3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\xC2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\xC1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\xC0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: ".",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: ",",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u201E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u201A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\xC5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\xC4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\xC3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\xC2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\xC1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\xC0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: ".",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: ",",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u201E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u201A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\xC5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\xC4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\xC3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\xC2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\xC1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\xC0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: ".",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: ",",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u201E",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u201A",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0153",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0152",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xFC",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xFB",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xFA",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF9",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF8",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF6",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF5",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF4",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF3",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF2",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xEB",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xEA",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE9",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE8",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE7",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE6",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE5",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE4",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE3",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE2",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE1",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE0",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xD8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xD6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xD5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xD4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xD3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xD2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC5",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC4",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC3",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC2",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC1",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC0",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "z",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "u",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "s",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "r",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "q",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "p",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "o",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "n",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "m",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "g",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "e",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "d",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "c",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "a",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "O",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "A",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "?",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ".",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ",",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u201E",
    k: 266
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u201A",
    k: 266
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xC5",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xC4",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xC3",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xC2",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xC1",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xC0",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "Z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "X",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "A",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: ".",
    k: 266
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: ",",
    k: 266
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\xFD",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "y",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "w",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\xFD",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "y",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "w",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\xFD",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "y",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "w",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\xFD",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "y",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "w",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\xFD",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "y",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "w",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\xFD",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "y",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "w",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\xFD",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "y",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "w",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\xFD",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "y",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "w",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u201D",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u2019",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "'",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\"",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\xFD",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "y",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "w",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: "\u201E",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: "\u201D",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: "\u201A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: "\u2019",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: "?",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: ".",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: ",",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: "'",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: "\"",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xFD",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "y",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "w",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "'",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\"",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: "\u201E",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: "\u201D",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: "\u201A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: "\u2019",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: "?",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ".",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ",",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: "'",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: "\"",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0152",
    u2: "J",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u201E",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u201A",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u0153",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u0152",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xFC",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xFB",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xFA",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF9",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF8",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF6",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF5",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF4",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF3",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF2",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xEB",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xEA",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE9",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE8",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE7",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE6",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE5",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE4",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE3",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE2",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE1",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE0",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xD8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xD6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xD5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xD4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xD3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xD2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC5",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC4",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC3",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC2",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC1",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC0",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "z",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "u",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "s",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "r",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "q",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "p",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "o",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "n",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "m",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "g",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "e",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "d",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "c",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "a",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "O",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "A",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "?",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ".",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ",",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "T",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "T",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0178",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0153",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xFC",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xFB",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xFA",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF9",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF8",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF6",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF5",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF4",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF3",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF2",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xEB",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xEA",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE9",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE8",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE7",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE6",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE5",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE4",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE3",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE2",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE1",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE0",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xDD",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC5",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC4",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC3",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC2",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC1",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC0",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "u",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "s",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "r",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "q",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "p",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "o",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "n",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "m",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "g",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "e",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "d",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "c",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "a",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "Y",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "W",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "V",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "T",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "A",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0178",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0153",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xFC",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xFB",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xFA",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xF9",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xF8",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xF6",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xF5",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xF4",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xF3",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xF2",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xEB",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xEA",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xE9",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xE8",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xE7",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xE6",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xE5",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xE4",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xE3",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xE2",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xE1",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xE0",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xDD",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC5",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC4",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC3",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC2",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC1",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC0",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "u",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "s",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "r",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "q",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "p",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "o",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "n",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "m",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "g",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "e",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "d",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "c",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "a",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "Y",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "W",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "V",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "T",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "A",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0178",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0152",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xDD",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xDC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xDB",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xDA",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD8",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD6",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD5",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD4",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD3",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD2",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xC7",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "Y",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "W",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "V",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "U",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "T",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "Q",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "O",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "G",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "C",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0178",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0153",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xFC",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xFB",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xFA",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF9",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF8",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF6",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF5",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF4",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF3",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF2",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xEB",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xEA",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE9",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE8",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE7",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE6",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE5",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE4",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE3",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE2",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE1",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE0",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xDD",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC5",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC4",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC3",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC2",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC1",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC0",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "u",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "s",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "r",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "q",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "p",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "o",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "n",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "m",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "g",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "e",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "d",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "c",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "a",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "Y",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "W",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "V",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "T",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "A",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0178",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0152",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xDD",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xDC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xDB",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xDA",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD8",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD6",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD5",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD4",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD3",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD2",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xC7",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "Y",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "W",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "V",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "U",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "T",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "Q",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "O",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "G",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "C",
    k: 102
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenSansRegularWebfont);
export default __webpack_public_path__ + "static/media/OpenSans-Regular-webfont.06064867021ce38795756f4eba4f29cd.svg";
export { ForwardRef as ReactComponent };